export default {
  title: 'Terms',
  type: 'object',
  properties: {
    name: {
      type: 'string',
      fieldRequired: true,
      maxLength: 500
    },
    content: {
      title: 'Treść regulaminu*',
      type: 'string',
      fieldRequired: true
    },
    order: {
      type: 'number',
      fieldRequired: true
    },
    profileType: {
      type: 'string',
      fieldRequired: false
    },
    required: {
      type: 'boolean'
    },
    mediaId: {
      title: 'Plik z treścią regulaminu*',
      type: 'number',
      fieldRequired: true
    },
    start: {
      title: 'Początek obowiązywania regulaminu*',
      type: 'string',
      format: 'date',
      fieldRequired: true
    }
  }
};
